import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MessageCircle, Phone } from 'lucide-react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AboutTherapist from './components/AboutTherapist';
import Services from './components/Services';
import TrustSection from './components/TrustSection';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import ContactInfo from './components/ContactInfo';
import Footer from './components/Footer';
import StickyBookingBar from './components/StickyBookingBar';

// Code-split SEO Service Pages for better performance
const BodyMassageBangalore = lazy(() => import('./pages/BodyMassageBangalore'));
const BodyMassageAtHomeBangalore = lazy(() => import('./pages/BodyMassageAtHomeBangalore'));
const AyurvedicMassageBangalore = lazy(() => import('./pages/AyurvedicMassageBangalore'));
const FullBodyMassageBangalore = lazy(() => import('./pages/FullBodyMassageBangalore'));
const HomeMassageServiceBangalore = lazy(() => import('./pages/HomeMassageServiceBangalore'));

// Loading fallback for lazy-loaded pages
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-cream">
    <div className="text-center">
      <div className="w-12 h-12 border-4 border-zen-gold border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
      <p className="text-coffee-700 font-semibold">Loading...</p>
    </div>
  </div>
);

import './index.css';

// Homepage Component
const HomePage = () => (
  <>
    <Hero />
    <AboutTherapist />
    <Services />
    <TrustSection />
    <Testimonials />
    <FAQ />
    <ContactInfo />
  </>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />

        <Suspense fallback={<PageLoader />}>
          <Routes>
            {/* Homepage */}
            <Route path="/" element={<HomePage />} />

            {/* SEO Service Pages - Lazy Loaded */}
            <Route path="/body-massage-in-bengaluru" element={<BodyMassageBangalore />} />
            <Route path="/body-massage-at-home-bengaluru" element={<BodyMassageAtHomeBangalore />} />
            <Route path="/ayurvedic-massage-bengaluru" element={<AyurvedicMassageBangalore />} />
            <Route path="/full-body-massage-bengaluru" element={<FullBodyMassageBangalore />} />
            <Route path="/home-massage-service-bengaluru" element={<HomeMassageServiceBangalore />} />
          </Routes>
        </Suspense>

        <Footer />

        {/* Floating Action Buttons - Call & WhatsApp */}
        <div className="fixed bottom-8 right-8 z-50 flex flex-col gap-3">
          {/* Call Button */}
          <a
            href="tel:+919901853969"
            className="bg-blue-600 text-white p-4 rounded-full shadow-premium hover:shadow-glow hover:bg-blue-700 transition-all duration-300 animate-float group"
            aria-label="Call Now"
          >
            <Phone size={32} />
            <span className="absolute right-full mr-3 bg-coffee-900 text-white px-4 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-sm font-semibold">
              Call: +91 9901853969
            </span>
          </a>

          {/* WhatsApp Button */}
          <a
            href="https://wa.me/919901853969"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-green-500 text-white p-4 rounded-full shadow-premium hover:shadow-glow hover:bg-green-600 transition-all duration-300 animate-float group"
            aria-label="Chat on WhatsApp"
          >
            <MessageCircle size={32} />
            <span className="absolute right-full mr-3 bg-coffee-900 text-white px-4 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-sm font-semibold">
              Chat on WhatsApp
            </span>
          </a>
        </div>

        {/* Sticky Booking Bar */}
        <StickyBookingBar />
      </div>
    </Router>
  );
}

export default App;

